var table_viewer_default = {
  "root": "LzDPZ",
  "viewMode": "mDQ8j",
  "editMode": "IVkpA",
  "container": "_2ElBq",
  "tableViewport": "oQP8M",
  "cell": "N1VVO"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
